// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import moment from 'moment'
import Vue from 'vue';
import VueI18n from "vue-i18n";
import App from './App'
import router from './router'
import store from "./store/store";
import globalAxiosObj from 'axios';
import axiosObj from 'axios';
import vSelect from 'vue-select';
import "vue-select/src/scss/vue-select.scss";
import en from "./en";
import nl from "./nl";
import fr from "./fr";
import flatpickr from "flatpickr";
import {english} from 'flatpickr/dist/l10n/default'
import {French} from 'flatpickr/dist/l10n/fr'
import {Dutch} from 'flatpickr/dist/l10n/nl'
import 'element-closest-polyfill';

//todo: user object from /user/me should also return relations


const messages = {
  en,
  nl,
  fr,
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages
});

const getRuntimeConfig = async () => {
  const runtimeConfig = await fetch('/static/runtimeConfig.json');
  return await runtimeConfig.json();
};


function startVue(i18n, router, store) {
  // console.log('starting vue');
  new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: {App},
    template: '<App/>'
  });
}

function defaultTheme(config) {
  const preferredTheme = localStorage.getItem('theme');
  if (!preferredTheme) {
    store.commit("setTheme", config.defaultTheme);
  } else {
    store.commit("setTheme", preferredTheme);
  }
  const theme = store.getters.getTheme;
  document.querySelector('html').classList.toggle(theme)
}

function defaultLang(config) {
  const language = localStorage.getItem('lang');
  if (!language) {
    store.commit("setLang", config.defaultLanguage);
  }
}


function init(config) {
  store.commit("setUrl", config.url);
  store.commit("setPort", config.port);
  store.commit("setConfig", {
    enableMailer: config.enableMailer,
    sendPasswordEmail: config.sendPasswordEmail
  });

  if (config.url !== 'default') {
    store.commit('setSetupStatus', true)
  } else {
    localStorage.clear();
  }
  defaultLang(config);
  defaultTheme(config);
}

async function loadUser(axios) {
  return await axios.get('/users/me')
}

async function getCountries() {
  const f = await fetch('/static/countries.json');
  return f.json();
}

getRuntimeConfig().then(function (config) {
  init(config);

  const countries = [];
  getCountries().then(r => {
    // console.log('countries', r)
    store.commit('setCountries', r);
  });


  const axios = axiosObj.create({
    baseURL: store.getters.getUrl + ':' + store.getters.getPort,
  });

  const globalAxios = globalAxiosObj.create({
    baseURL: store.getters.getUrl + ':' + store.getters.getPort,
  });

  // to prevent ie11 caching of requests
  axios.interceptors.request.use((config) => {
    config.params = config.params || {};
    config.params['id_ne'] = moment().unix() + 'nocache';
    return config;
  });


  // axios.defaults.params = {}
  // axios.defaults.params['id_ne'] = moment().unix()
  //
  // globalAxios.defaults.params = {}
  // globalAxios.defaults.params['id_ne'] = moment().unix()

  Vue.component('v-select', vSelect);
  Vue.config.productionTip = false;
  Vue.mixin({
    updated() {
      // this.initDatePickers()
    },
    mounted() {
      // this.initDatePickers()
    },
    created() { //todo if this gives issues, might have to change to mounted, but it breaks reading input value
      // console.log('created')
      this.initDatePickers()
    },
    data() {
      return {
        colors: [
          'rgba(192,216,73,0.50)',
          'rgba(244,116,39,0.50)',
          'rgba(250,226,57,0.50)',
          'rgba(24,139,113,0.50)',
          'rgba(237,28,36,0.50)',
          'rgba(7,67,87,0.50)',
          'rgba(13,147,207,0.5)',
          'rgba(90,90,90,0.50)',
        ],
        fp: null,
        axios: axios,
        siteConfig: store.getters.getConfig,
        globalAxios: globalAxios,
        allCountries: store.getters.getCountries
      }
    },

    computed: {

      userRole() {
        return store.getters.viewMode
      },

      accesslevel() {
        const user = store.getters.getUser;
        let level = parseInt(user.accesslevel)
        return level ? level : 0
      },
      today() {
        // return moment().format('d/m/Y');
        return moment().format('YYYY-MM-DD');
      },
      url() {
        return store.getters.getUrl + ':' + store.getters.getPort
      },
    },
    methods: {
      makeCSV(data) {
        let rows = [Object.keys(data[0])];
        let arrayData = [];

        data.forEach(function (row) {
          arrayData.push(Object.values(row));
        });

        rows = rows.concat(arrayData);

        let csvContent = "\uFEFF"; //universal BOM

        rows.forEach(function (rowArray) {
          let row = rowArray.join(";");
          csvContent += row + "\r\n";
        });

        return csvContent
      },
      downloadCsv(data,filename = 'download'){
        const csvContent = this.makeCSV(data);

        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(new Blob([csvContent], {type: 'text/csv;charset=ISO-8859-1'}), filename + ".csv");
        } else {
          let blob = new Blob([csvContent], {type: 'text/csv;charset=windows-1252;'});
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute("download", filename+".csv");
          document.body.appendChild(link); // Required for FF
          link.click(); // This will download the data file named "my_data.csv".
        }
      },

      async sendMail(to, from, subject, body) {
       // console.log('config', this.siteConfig)
        if (this.siteConfig.enableMailer) {
          return await this.axios.post('/mailer', {
            to,
            from,
            subject,
            text: body
          })
        } else {
          return 'disabled in config'
        }
      },
      async sendPasswordMail(to, from, subject, body) {
       // console.log('config', this.siteConfig)
        if (this.siteConfig.sendPasswordEmail) {
          return await this.axios.post('/mailer', {
            to,
            from,
            subject,
            text: body
          })
        } else {
          return 'disabled in config'
        }
      },
      isEmptyOrSpaces(str) {
        return str === null || str.match(/^ *$/) !== null;
      },
      loadingSuccess(el) {
        el.blur();
        el.classList.add('success');
        setTimeout(() => {
          el.classList.remove('loading');
          el.classList.remove('success');
        }, 1200);
      },
      formatDate(date) {
        let m = moment(date);
        if (!m.isValid()) {
          m = ''
        } else {
          m = m.format('DD/MM/YYYY')
        }
        return m
      },
      fullGender(gender) {
        switch (gender) {
          case 'm':
            return this.$t('message.male');
          case 'f':
            return this.$t('message.female');
          default:
            return ''
        }
      },
      calcStandardDeviation(values) {
        var avg = this.calcAverage(values);

        var squareDiffs = values.map(function (value) {
          var diff = value - avg;
          var sqrDiff = diff * diff;
          return sqrDiff;
        });

        var avgSquareDiff = this.calcAverage(squareDiffs);

        var stdDev = Math.sqrt(avgSquareDiff);
        return stdDev;
      },
      calcAverage(data) {
        var sum = data.reduce(function (sum, value) {
          return sum + value;
        }, 0);

        var avg = sum / data.length;
        return avg;
      },
      initDatePickers() {
        // console.log('initdate')
        let options = {
          altInput: true,
          altFormat: "d/m/Y",
          maxDate: moment().format('YYYY-MM-DD')
        };
        setTimeout(() => {
          const datefields = document.querySelectorAll('input[type="date"]');
          datefields.forEach(field => {
            //   console.log('fieldval',field.value)
            const pickr = flatpickr(field,
              options,
            );
            pickr.setDate(field.value)
            store.commit('addFlatpickr', field)
          });
        }, 50)

      },
      validateAlphanumeric(string) {
        let pattern = new RegExp(/^([áéíóúýàèìòùâêîôûäëïöüÿçñæœa-zA-Z0-9\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9 _.-]+)$/i);
        const testResult = pattern.test(string);
        //  console.log('testing regex', testResult);
        return testResult;
      },
      isEmptyObject(obj) {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop))
            return false;
        }
        return true;
      },
      async fetchCurrentUser() {
        return await axios.get('/users/me').then(r => {
          return r
        })
      },
      safeName(string) {
        if(!string){
          string = '';
        }
        let clean = string.toLowerCase();
        clean = clean.replace(/ /g, '-');
        return clean
      },
      localizedField(entity, field) {
        const lang = store.getters.getLang;
        let output = '';
        let translation = null;
        if (lang !== 'nl') { //because fields have been filled default as nl
          translation = entity[field + '_' + lang];
          if (!translation || translation.length < 1) {
            output = entity[field]
          } else {
            output = translation;
          }
        } else {
          output = entity[field];
        }
        return output;
      },
      toggleTheme() {
        const theme = store.getters.theme;
        let newtheme = '';
        if (theme === 'darkmode') {
          newtheme = 'lightmode'
        } else {
          newtheme = 'darkmode'
        }
        store.dispatch('setTheme', newtheme);
        document.querySelector('html').classList.toggle('lightmode');
        document.querySelector('html').classList.toggle('darkmode')
      },

      async getVitaminSubmission(id) {
        let request = '/submissions/' + id; //show last finalized, unless reviewing the last finalized, in that case show the one before that
        let res = await axios.get(request);
        const ret = res;
        return ret
      },

      async getDraftVitamin() {
        let ep = '/submissions';
        let data = await axios.get(ep + '?status=draft&_sort=submitted:DESC&_limit=1');
        let ret = null;
        if (data.data[0]) {
          ret = data.data[0]
        }
        return ret;
      },

      async getLatestSubmission(uid = null) {
        let call = '/submissions/';
        let params = '?status_ne=draft&_sort=finalized:DESC&_limit=1';
        if (uid) {
          call = '/submissions/user/' + uid;
          params += '&published=1'
        }
        return await axios.get(call + params);
      },

      async getSubmissionAnswers(submission_id){
        return await axios.get('/answers/?submission='+submission_id)
      },

      async getCurrentVitamin(uid = null) {
        let ep = '/submissions/user/' + uid;
        let arg = '';
        if (uid === null) {
          uid = store.getters.getUserId;
          ep = '/submissions/'
        } else {
          arg = '&published=1'
        }
        let id = '';
        //todo: arguments do not work on custom manager call
        let data = await axios.get(ep + '?status_ne=draft&_sort=finalized:DESC&_limit=1' + arg);
        let ret = null;
        if (data.data[0]) {
          ret = data.data[0]
          // id = data.data[0].id
        }
        return ret;
        // return await this.getVitaminSubmission(id)
      },

      async getPreviousVitamin(vitamin_id, uid = null) {
        if (uid === null) {
          uid = store.getters.getUserId;
        }
        const controlVitamin = await this.getVitaminSubmission(vitamin_id);
        let cdata = controlVitamin.data
        let response = '';
        let ep = '/submissions?status=reviewed&_sort=reviewed:DESC&finalized_lt=' + cdata.finalized + '&_limit=1';
        if (uid !== store.getters.getUserId) {
          ep = '/submissions/user/' + uid + '?status=reviewed&_sort=reviewed:DESC&finalized_lt=' + cdata.finalized + '&_limit=1';
        }
        response = await axios.get(ep);

        let res = null;
        if (response.data[0]) {
          res = response.data[0]
        }

        return res;
      },

      calcAge(birthdate) {
        let bd = new Date(birthdate);
        let now = new Date();
        let diff = now.getTime() - bd.getTime();
        let age = Math.floor(((((diff / 1000) / 60) / 60) / 24) / 365);
        return age;
      },
      getDatesBetween(startDate, stopDate, returnFormat = 'D/M/YYYY') {
        let min = moment('2020-01-01');
        if (moment(startDate) < min) {
          startDate = min.format('YYYY-MM-DD');
        }

        var dateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);

        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format(returnFormat));
          currentDate = moment(currentDate).add(1, 'days');
        }
        return dateArray;
      },

      reloadTree() {
        axios.get('/teams').then(teams => teams.data)
          .then(res => {
            store.dispatch('setTree', res[0])
            // .then(() => console.log('reloaded tree'));
          });
      },

      capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },

      toReadableDate(m) {
        return m.getUTCDate() + '/' + (m.getUTCMonth() + 1) + '/' + m.getUTCFullYear()
      },
      maximize(event) {
        //    console.log('maximizing', event)
        document.querySelector('body').classList.add('maximized-on')
        let el = event.target.closest('.maximizable');
        el.classList.add('maximized');
      },
      minimize(event) {
        document.querySelector('body').classList.remove('maximized-on')
        let el = event.target.closest('.maximizable');
        el.classList.remove('maximized');
      },
      truncate(num = 0, fixed, type = 'number') {
        let ret = '';
        if (type === 'number') {
          if (!num) {
            num = 0
          }
          if (num > 0) {
            var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
            ret = num.toString().match(re)[0];
          } else {
            ret = '--'
          }
        } else {
          if (num.length <= fixed) {
            return num
          }
          ret = num.slice(0, fixed) + '.'
        }


        return ret;
      },
      async logActivity(msg, level) {
        // console.log('starting log activity', [msg, level])
        let uid = store.state.userId;
        return await axios.post('/activitylogs', {
          user: uid,
          action: msg,
          loglevel: level,
          timestamp: new Date()
        })
      },
      validateMail(mail) {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail);
      }
    }
  });


  if (config.url !== 'default') {
    const token = localStorage.getItem('user-token');

    let tokenValid = true;
    //todo test if token works before continuing

    if (token && tokenValid) {
      axios.defaults.headers = {
        Authorization:
          'Bearer ' + token,
      };

      axios.get('/teams/myteam').then(r => {
        store.commit('setManagedTeams', r.data);
      }).catch(r => {
        store.commit('signOut');
        startVue(i18n, router, store)
      });

      loadUser(axios).then(u => {
        const user = u.data;
        // const storedUser = store.getters.getUser;
        // if (storedUser && user !== storedUser) {
        //   /*this makes sure token matches stored user*/
        //   store.commit('signOut');
        //   startVue(i18n, router, store)
        // } else {
        store.commit("setUser", user);
        axios.get('/companies?_sort=created_at:DESC&_limit=1').then(r => {
          const company = r.data[0];
          store.commit("setCompany", company);
          startVue(i18n, router, store)
        })
        // }

      }).catch(r => {
        store.commit('signOut');
        startVue(i18n, router, store)
      });


    } else {
      axios.get('/companies?_sort=created_at:DESC&_limit=1').then(r => {
        // console.log('load company',r)
        const company = r.data[0];
        store.commit("setCompany", company);
        startVue(i18n, router, store)
      })
      // startVue(i18n, router, store)
    }
  } else {
    startVue(i18n, router, store)
  }


  /* eslint-disable no-new */

  // startVue(i18n,router,store);

  const lang = store.getters.getLang;
  i18n.locale = lang;


  switch (lang) {
    case 'nl':
      flatpickr.localize(Dutch); //
      break;
    case 'en':
      flatpickr.localize(english); //
      break;
    case'fr':
      flatpickr.localize(French); //
      break;
    default:
      break;
  }
});







// WEBPACK FOOTER //
// ./src/main.js